// extracted by mini-css-extract-plugin
module.exports = {"request-code-wait-timer-window":"RestorePassword_request-code-wait-timer-window__ePny_","form-bottom":"RestorePassword_form-bottom__34-Zi"};